import { useState } from 'react';
import { useGlobalKeyHandler } from './useGlobalKeyHandler';

/** Manages a number between 0 (inclusive) and the given length (exclusive).
 *
 * Changes this number, with wrapping, when the user presses up/down arrow keys.
 */
export const useArrowKeyIndex = (length: number) => {
  const [state, setState] = useState(0);

  useGlobalKeyHandler('ArrowDown', () => {
    setState((state + 1 + length) % length || 0);
  });

  useGlobalKeyHandler('ArrowUp', () => {
    setState((state - 1 + length) % length || 0);
  });

  /** Handle the length changing (and potentially becoming zero)  */
  const wrappedState = state % length || 0;

  return [wrappedState, setState] as const;
};
